import Playable from 'playable';
import HLSAdapter from 'playable/dist/src/adapters/hls';

Playable.registerPlaybackAdapter(HLSAdapter);

const ADAPTIVE_MIN_DURATION = 30000;

function filterSource(sources: any[], duration: number) {
  if (duration > ADAPTIVE_MIN_DURATION) {
    return sources.filter((source) => source.quality === 'ADAPTIVE');
  } else {
    return sources
      .filter((source) => source.quality !== 'ADAPTIVE')
      .sort((source1, source2) =>
        parseInt(source1.quality, 10) > parseInt(source2.quality, 10) ? 0 : 1,
      );
  }
}

export function create(id: string, params: any = {}) {
  const player = Playable.create({
    ...params,
    hideOverlay: true,
    overlay: false,
  });

  const setID = (id: string) => {
    player.pause!();

    return window.VideoGallerySDK.getInfo(id).then((info: any) => {
      return Promise.all([
        window.VideoGallerySDK.getVideoURLs(info),
        window.VideoGallerySDK.getVideoMetadata(info),
      ]).then(([urls, metadata]) => {
        player.setSrc!(filterSource(urls, metadata.duration)[0]);
      });
    });
  };

  const destroy = () => {
    player.destroy();
  };

  setID(id);

  return {
    setID,
    play: player.play,
    pause: player.pause,
    attachToElement: (node: any) => player.attachToElement!(node),
    destroy,
    player,
  };
}
